import { useEffect, useState } from "react";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import { BalanceSheetSourceItem, BalanceSheetTechItem } from "../models/BalanceSheetModel";
import Modal from "../../../../components/base/Modal";
import { useHub } from "../../../../core/Global";
import { toastError, toastSuccess } from "../../../../components/base/Toast";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";


interface IProps {
    tech?: BalanceSheetTechItem
    source?: BalanceSheetSourceItem
    onClose?: () => void
}
export default function BalanceItemViewDrawer(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    })

    const hub = useHub()

    const [balance, balanceSet] = useState<number>(0)
    const [alsoSettleJobs, alsoSettleJobsSet] = useState<boolean>(true)

    useEffect(() => {
        if (props.tech) balanceSet(props.tech.balance)
        if (props.source) balanceSet(props.source.balance)
    }, [props.tech, props.source])

    return (
        <Modal id="modal-balance-item-view"
            title={props.tech?.tech.fullName ?? props.source?.name ?? ""}
            open visible
            onClose={props.onClose}
            buttonText="Settle Balance"
            onConfirm={callback => {

                if (props.tech) {

                    hub.Post("/reports/balance/settletech", {
                        techId: props.tech?.tech.id,
                        alsoSettleJobs: alsoSettleJobs
                    }, res => {
                        if (res.success) toastSuccess("The technician has been settled successfully!")
                        else toastError(res.message)
                        callback(!res.success)
                    })

                }

                if (props.source) {

                    hub.Post("/reports/balance/settlesource", {
                        sourceId: props.source.id,
                        alsoSettleJobs: alsoSettleJobs
                    }, res => {
                        if (res.success) toastSuccess("The source has been settled successfully!")
                        else toastError(res.message)
                        callback(!res.success)
                    })

                }


            }}>

            <div className="">

                <FlexRow className="mb-10">
                    <Icon icon={props.tech ? "user-helmet-safety" : "bullhorn"} className="fs-2hx text-gray-600 me-2" />
                    <div className="d-flex flex-column">
                        <span className={`fw-bold fs-1 ${(balance > 0 ? "text-success" : balance < 0 ? "text-danger" : "text-gray-800")}`}>
                            {(balance > 0 ? "+" : "")}{moneyFormatter.format(balance)}
                        </span>
                        <div className="m-0">
                            <span className="fw-semibold fs-7 text-gray-500">
                                {props.tech ? "Technician" : "Source"} Balance
                            </span>
                        </div>
                    </div>
                </FlexRow>

                <div>
                    <ToggleSwitch label="Also mark all related jobs as settled!"
                        raw small checked={alsoSettleJobs} onChange={e => alsoSettleJobsSet(e)} />
                </div>

            </div>

        </Modal>
    )
}